// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"hero-image_imageContainer__jwtkH","isShownOnMobile":"hero-image_isShownOnMobile__Uwuik"};